import axios from "axios";
import { useEffect, useState } from "react";
import Sidebar from "../layout/Sidebar";
import ChangePassword from "../edit/ChangePassword";

export default function ViewProfile(props){

    const [data, setData]=useState([]);
    const [editform, seteditform] = useState(false);

    function getData(){
        axios.get(`${process.env.REACT_APP_BASE_URL}api/user/secured/getLoginUser`)
        .then(result=>setData(result.data))
        .catch(err=>console.log(err));
    }
   useEffect(()=>getData(),[]);

   return (<>
   <div className="container-fluid">
      {editform && <>
      <div className="dialog-container">
         <ChangePassword event={seteditform}></ChangePassword>
      </div>
      </>}
   </div>
   <div className="container-fluid">
      <div className="row">
         <div className="col-12 col-md-3 col-lg-2 sidebar-container">
             <Sidebar></Sidebar>
         </div>
         <div className="col-12 col-md-9 col-lg-10 main-container">
            <div className="container mt-4">
               <h2 className="text-center">My Profile</h2>
               <hr />
               <div className="row">
                  <div className="col-12 col-md-9 col-lg-5">
                     <p><strong>FullName: </strong>{data.fullname || "Null"}</p>
                     <p><strong>Email: </strong>{data.email || "Null"}</p>
                     <p><strong>Mobile: </strong>{data.mobile || "Null"}</p>
                  </div>
                  <div className="col-12 col-md-9 col-lg-5">  
                     <p><strong>Role: </strong>{data.role || "Null"}</p>
                     <p><strong>Status: </strong>{data.status || "Null"}</p>
                  </div>
               </div>
               <div>
                  <button className="btn btn-color" onClick={()=>seteditform(true)}>Change Password</button>
               </div>
            </div>
         </div>
      </div>
   </div>
</>);
}